module.exports = fox._r("components/strip-notification/fonts/strip-notification.svg?2a2d6v", __webpack_public_path__ + "_/_/_/root/components/strip-notification/fonts/strip-notification.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/strip-notification/fonts/strip-notification.svg?2a2d6v
// module id = 553
// module chunks = 4